/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ModalBackdrop = React.forwardRef((props, ref) => {

  const {
    open,
    onClick,
    component = 'div',
    className,
    ...other
  } = props;

  const Root = component;

  const styles = [
    'sui-fixed',
    'sui-flex',
    'sui-z-[-1]',
    'sui-items-center',
    'sui-justify-center',
    'sui-top-0 sui-right-0 sui-bottom-0 sui-left-0',
    'sui-bg-inverse',
    'sui-opacity-50',
  ].join(' ');

  return (
    <Root
      aria-hidden
      as={component}
      className={styles}
      ref={ref}
      onClick={onClick}
      {...other}
    />
  );
});

ModalBackdrop.displayName = 'ModalBackdrop';

ModalBackdrop.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  component: PropTypes.elementType,
  open: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};

ModalBackdrop.defaultProps = {};

export { ModalBackdrop };